import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2963c74c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ruler" }

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'

interface ViewportStyles {
  top: number
  left: number
  width: number
  height: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Ruler',
  props: {
    viewportStyles: {}
  },
  setup(__props: any) {

const props = __props

const { canvasScale } = storeToRefs(useMainStore())

const markerSize = computed(() => {
  return props.viewportStyles.width * canvasScale.value / 10
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h",
      style: _normalizeStyle({
        width: _ctx.viewportStyles.width * _unref(canvasScale) + 'px',
        left: _ctx.viewportStyles.left + 'px',
      })
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (marker) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["ruler-marker-100", { 'hide': markerSize.value < 36, 'omit': markerSize.value < 72 }]),
          key: `marker-100-${marker}`
        }, [
          _createElementVNode("span", null, _toDisplayString(marker), 1)
        ], 2)
      }), 64))
    ], 4),
    _createElementVNode("div", {
      class: "v",
      style: _normalizeStyle({
        height: _ctx.viewportStyles.height * _unref(canvasScale) + 'px',
        top: _ctx.viewportStyles.top + 'px',
      })
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (marker) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["ruler-marker-100", { 'hide': markerSize.value < 36, 'omit': markerSize.value < 72 }]),
          key: marker,
          style: _normalizeStyle({ height: markerSize.value + 'px' })
        }, [
          _createElementVNode("span", null, _toDisplayString(marker), 1)
        ], 6)
      }), 64))
    ], 4)
  ]))
}
}

})